import styled from 'styled-components';

export const StyleOptions = styled.div`
  display: inline-flex;
  gap: 0.97rem;
  margin-bottom: 1.45rem;
  background: #f8f8f8;
  padding: 0.97rem;
  border-radius: 7px;
  width: 100%;
  justify-content: center;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const StyleOption = styled.button`
  width: 90px;
  height: 90px;
  border: 2px solid ${props => props.selected ? '#4AE66E' : 'transparent'};
  border-radius: 7px;
  background: ${props => props.selected ? 'white' : '#fff'};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.73rem;
  padding: 0.73rem;
  color: ${props => props.selected ? '#1e1e1e' : '#666'};
  font-size: 0.8125rem;
  font-weight: ${props => props.selected ? '600' : '400'};
  transition: all 0.1s ease;
  box-shadow: ${props => props.selected ? '0 2px 8px rgba(74, 230, 110, 0.15)' : '0 1px 3px rgba(0, 0, 0, 0.05)'};

  &:hover {
    background: white;
    border-color: ${props => props.selected ? '#4AE66E' : '#ddd'};
    transform: translateY(-1px);
    box-shadow: ${props => props.selected ?
        '0 4px 12px rgba(74, 230, 110, 0.2)' :
        '0 3px 6px rgba(0, 0, 0, 0.08)'};
  }
`;

export const ShapeExample = styled.div`
  width: ${props => props.type === 'vertical' ? '24px' : '36px'};
  height: ${props => props.type === 'horizontal' ? '24px' : '36px'};
  background: ${props => props.selected ? '#4AE66E' : '#666'};
  border-radius: 4px;
  transition: all 0.1s ease;
  margin-bottom: ${props => props.type === 'horizontal' ? '6px' : '0'};
`; 